/**
 * 协议相关配置（可单独配置）
 * - productName / companyName：产品与运营主体名称，支持通过 URL 参数 appname 覆盖产品名
 * - contact：联系方式，可单独维护
 *
 * 多语言说明：
 * 名称与联系方式通常与语言无关，这里作为全局配置；
 * 协议正文（多语言差异较大）放在 src/agreements 中，按语言分文件维护。
 */
export const agreementConfig = {
	// 产品名称（中文）。可通过 URL 参数 ?appname=xxx 覆盖
	productName: '轻语Ai',
	// 产品名称（其它语言统一使用的品牌英文名）。除中文外，其余语言均展示该名称
	productNameEn: 'QingYuAi',
  // 运营主体 / 公司名称
  companyName: '深圳数芯语科技有限公司',
  // 联系方式（可单独配置）
  contact: {
    // 联系邮箱
    email: 'market@nihaoxiaozhi.com',
    // 联系地址
    address: '深圳市光明区凤凰街道塘尾社区明湖智谷产业园6栋1002',
    // 应用内反馈路径
    appFeedback: '登录产品界面 → 点击「联系我们」'
  }
}

export default agreementConfig
